import { env } from '../../config/env';

export const API_URL = `${env.BASE_API_URL}/admin-api`;
export const ADDRESSES_API_URL = `${env.BASE_API_URL}/addresses-api`;
export const AUCTION_URL = env.AUCTION_URL;
export const FRONTEND_URL = env.FRONTEND_URL;

export const AUTHORIZATION_TOKEN_STORAGE_KEY = 'auth_token';
export const REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';
export const AUTHORIZATION_TOKEN_EXPIRES = 24;

export enum ResponseStatusCodes {
  SUCCESS = 200,
  ACCEPTED = 202,
  TEMPORARY_REDIRECT = 307,
  BAD_REQUEST = 400,
  NOT_AUTHORIZED = 401,
  SESSION_ENDED = 403,
  NOT_FOUND = 404,
  SOMETHING_WRONG = 418,
  SERVER_ERROR = 500,
}

export const SEO_TITLE_SITE = '';

export const MAX_NUMBER_LENGTH = 16;
